// extracted by mini-css-extract-plugin
module.exports = {"single-example-title":"_2EFbn","singleExampleTitle":"_2EFbn"};